{
  "error-messages": {
    "unable-to-create-user": "Користувача не існує. Будь ласка, зверніться до адміністратора.",
    "incorrect-credentials": "Неправильне ім'я користувача або пароль."
  },

  "form": {
    "title": "Увійти за допомогою Е-пошти",

    "email": {
      "label": "Електронна пошта",
      "placeholder": "maill@mail.zz"
    },

    "password": {
      "label": "Пароль",
      "placeholder": "Мінімум 8 символів, одна велика і одна мала літера"
    },

    "forgot-pass-link": "Забули пароль?",

    "submit": {
      "label": "Підтвердити",
      "loading": "Завантаження"
    }
  }
}
